export interface IFeatureToggle {
  id: number;
  code: string;
  active: boolean;
}
